import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const SidebarHeader = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): ReactElement => (
  <div
    {...props}
    className={clsx(
      "flex flex-col border-b border-zinc-950/5 p-4 dark:border-white/5 [&>[data-slot=section]+[data-slot=section]]:mt-2.5",
      className,
    )}
  />
);
